import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from "../components/Link";
import { _fetchMatches } from "../modules/matches";

class MatchList extends Component {
  state = {
    matches: []
  };

  componentDidMount() {
    _fetchMatches()
      .then(matches => {
        this.setState({ matches })
      })
  }

  render() {
    const { matches } = this.state;
    return (
      <div>
        <ul>
          {matches.map(match => <li><Link key={'link_'+match.shortId} to={{
            routeName: 'Match',
            params: { id: match.shortId, match }
          }}>{match.players.map(p => p.name).join(' - ')}</Link></li>)}
        </ul>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {};
})(MatchList);



// WEBPACK FOOTER //
// ./src/scenes/MatchList.js